import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  convertAmount,
  DefaultQueryParams,
  parseQuery,
  setTranslationValues,
  useTranslation,
} from '@pascal/pascal-core';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';

import { observer } from 'mobx-react-lite';
import RulesImage1 from '../../assets/images/crazy-worm-rules/rules_image.png';
import { TranslationKeys } from '../../enums/translationKeys';
import { RtlLanguages } from '../../enums/rtlLanguages.enum';

export const HelpPopup = observer(() => {
  const t = useTranslation();
  const { search } = useLocation();
  const { limits = {}, gameConfiguration = {} } = gameConfigStore;
  const { currencySymbolOrCode } = userInfoStore;
  const { autobet: isAutoBetConfigEnabled } = gameConfiguration;

  const { [DefaultQueryParams.Culture]: language } = parseQuery(search);

  const isRtl = RtlLanguages.find((el) => el === language);

  return (
    <div className='tb-game-rules-wrapper'>
      <p>{t(TranslationKeys.GAME_NAME)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P1)}</p>
      <div className='bet_button_rules'>{t(TranslationKeys.Bet)}</div>
      <p>{t(TranslationKeys.GAME_RULES_P2)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P3)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P4)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P5)}</p>
      <p>{t(TranslationKeys.GAME_RULES_P6)}</p>
      <br />
      <div className='num_data_rules'>
        <p>{t(TranslationKeys.TargetMultiplier)}</p>
        <p>{t(TranslationKeys.WinChance)}</p>
      </div>
      {isAutoBetConfigEnabled && (
        <>
          <p>{t(TranslationKeys.GAME_RULES_P7)}</p>
          <p>{t(TranslationKeys.GAME_RULES_P8)}</p>
          <img src={RulesImage1} alt='#' />
        </>
      )}

      <p>{t(TranslationKeys.ADDITIONAL_INFO)}</p>
      <p className={isRtl ? 'textRtl' : ''}>
        {setTranslationValues(t(TranslationKeys.MIN_BET), { Value: '' })} -{' '}
        <span>
          {convertAmount(limits.minBet)} {currencySymbolOrCode}
        </span>
      </p>
      <p className={isRtl ? 'textRtl' : ''}>
        {setTranslationValues(t(TranslationKeys.MAX_BET), { Value: '' })} -{' '}
        {convertAmount(limits.maxBet)} {currencySymbolOrCode}
      </p>
      <p className={isRtl ? 'textRtl' : ''}>{`${t(TranslationKeys.MAX_ODD)} - x10,000`}</p>
      <p className={isRtl ? 'textRtl' : ''}>
        {setTranslationValues(t(TranslationKeys.MAX_WIN), { Value: '' })}
        <span>
          {convertAmount(limits.maxWin)} {currencySymbolOrCode}
        </span>
      </p>
      <p>{t(TranslationKeys.RTP)}</p>
      <p>
        {t(TranslationKeys.CANCELATION_MESSAGE_1)}
        <br />
        <br />
        {t(TranslationKeys.MALFUNCTION_MESSAGE_2)}
      </p>
    </div>
  );
});
